import type { VariantVideosDefinition } from 'types/videos'

import type { F01_VIDEOS } from './default'

export const F01_DARK_VIDEOS = {
  fitnessLevelSquats: {
    gymVisualsSquat: {
      src: '/videos/f01/dark/fitness-level/squat-gym-visual.webm',
    },
  },
  fitnessLevelCrunches: {
    gymVisualsCrunches: {
      src: '/videos/f01/dark/fitness-level/crunches-gym-visual.webm',
    },
  },
  fitnessLevelPlank: {
    gymVisualsPlank: {
      src: '/videos/f01/dark/fitness-level/plank-gym-visual.webm',
    },
  },
} satisfies VariantVideosDefinition<typeof F01_VIDEOS>
